import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import isEmpty from "lodash/isEmpty";
import Form, { FORM_HORIZONTAL_LAYOUT } from "../Form";
import useFormSubmit from "../Form/useFormSubmit";
import { reloadTable } from "../SmartTable/reducer";
import { closeModalAction } from "../Modal/reducer";
import { FORM_ITEM_TEXT } from "../Form/FormItems/FormItemText";
import Button from "../Button";
import { FORM_ITEM_CHECKBOX } from "../Form/FormItems/FormItemCheckbox";
import { renderDynamicallyFields } from "../Form/methods";
import { useModalData } from "../Modal/useModalData";

const SettingsNameActiveForm = ({
  modalName,
  tableName,
  apiRoute,
  translations,
  extraFields = [],
  transformer,
  initialValues: customInitialValues
}) => {
  const data = useModalData(modalName);
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isNewRecord = isEmpty(data);
  const { loading, submit, generalError } = useFormSubmit({
    route: isNewRecord ? apiRoute : `${apiRoute}/${data.id}`,
    method: isNewRecord ? "post" : "put",
    form,
    transformer: transformer ? (values) => transformer(values, data, isNewRecord) : undefined,
    onSuccess: () => {
      dispatch(reloadTable({ name: tableName, resetFilters: isNewRecord }));
      dispatch(closeModalAction({ name: modalName }));
    }
  });

  const defaultInitialValues = { ...data, active: isNewRecord ? true : data?.active };
  const initialValues = customInitialValues
    ? customInitialValues(data, isNewRecord, defaultInitialValues)
    : defaultInitialValues;

  return (
    <Form
      onSubmit={submit}
      form={form}
      errors={generalError}
      loading={loading}
      initialValues={initialValues}
      layout={FORM_HORIZONTAL_LAYOUT}
      header={
        <>
          <div className="h3">{t(isNewRecord ? translations.newTitle : translations.editTitle)}</div>
          <div className="mb-30 mt-10 h6 font-weight-300 text-muted">{t("container.general_words.form_subtitle")}</div>
        </>
      }
    >
      {renderDynamicallyFields([
        {
          required: true,
          type: FORM_ITEM_TEXT,
          max: 200,
          name: "name",
          label: translations.nameLabel,
          placeholder: translations.nameLabel
        },
        {
          type: FORM_ITEM_CHECKBOX,
          visible: isNewRecord,
          name: "active",
          label: translations.activeLabel
        },
        ...extraFields.map((field) => (typeof field === "function" ? field(isNewRecord, data) : field))
      ])}
      <div className="flex mt-25 flex-justify-end">
        <Button
          className="min-w-150"
          type="primary"
          htmlType="submit"
          disabled={loading}
          loading={loading}
          icon={<i className="ti-check" />}
        >
          {t("container.general_words.save")}
        </Button>
      </div>
    </Form>
  );
};

export default SettingsNameActiveForm;
